// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"248":"27f4cff8","498":"cd1ec635","703":"494b74f9","787":"06c578ed"}[chunkId] + ".chunk.js";
};